"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var whatFieldWasChanged = function whatFieldWasChanged(oldFormData, newFormData) {
  var changedField = void 0;

  (0, _entries2.default)(newFormData).forEach(function (entry) {
    var key = entry[0];
    var newValue = entry[1];

    if (oldFormData[key] !== newValue) {
      changedField = key;
    }
  });

  return changedField;
};

exports.default = whatFieldWasChanged;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/utils/whatFieldWasChanged.js
// module id = 1130
// module chunks = 5